document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.getElementById("carousel");
  const slides = document.querySelectorAll(".slide");
  let currentIndex = 0;
  let intervalId;

  const videos = document.querySelectorAll(".slide video");

  // 自动轮播函数
  function startAutoPlay() {
    intervalId = setInterval(() => {
      nextSlide();
    }, 10000); // 每10秒切换一次
  }

  // 停止自动轮播
  function stopAutoPlay() {
    clearInterval(intervalId);
  }

  // 更新轮播位置
  function updateCarousel() {
    carousel.style.transform = `translateX(-${currentIndex * 100}%)`;

    // 暂停所有视频
    videos.forEach((video) => {
      video.pause();
    });

    // 播放当前视频并重置到开始
    const currentVideo = slides[currentIndex].querySelector(".slide video");
    if (currentVideo) {
      currentVideo.currentTime = 0;
      currentVideo.play().catch((e) => console.log("Autoplay prevented:", e));
    }
  }

  // 下一张幻灯片
  function nextSlide() {
    currentIndex = (currentIndex + 1) % slides.length;
    updateCarousel();
  }

  // 上一张幻灯片
  function prevSlide() {
    currentIndex = (currentIndex - 1 + slides.length) % slides.length;
    updateCarousel();
  }

  // 跳转到指定幻灯片
  function goToSlide(index) {
    currentIndex = index;
    updateCarousel();
    stopAutoPlay();
    startAutoPlay();
  }

  // 切换幻灯片
  function changeSlide(direction) {
    if (direction > 0) {
      nextSlide();
    } else {
      prevSlide();
    }
    stopAutoPlay();
    startAutoPlay();
  }

  // 初始化
  updateCarousel();
  startAutoPlay();

  // 鼠标悬停时暂停自动轮播
  carousel.addEventListener("mouseenter", stopAutoPlay);
  carousel.addEventListener("mouseleave", startAutoPlay);

  // 按钮事件监听
  document
    .querySelector(".prev")
    .addEventListener("click", () => changeSlide(-1));
  document
    .querySelector(".next")
    .addEventListener("click", () => changeSlide(1));
});
